var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpringBoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-spring-boot (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.385 32.558C36.262 36.86 30.734 37.091 25.531 37H18.75H16.812C21.24 35.407 23.875 35.028 26.566 33.6C31.634 30.935 36.644 25.104 37.687 19.038C35.757 24.874 29.908 29.888 24.578 31.927C20.926 33.32 14.33 34.672 14.33 34.672L14.063 34.527C9.57301 32.268 9.43701 22.214 17.6 18.968C21.174 17.545 24.593 18.327 28.454 17.375C32.576 16.363 37.344 13.167 39.284 9C41.456 15.667 44.07 26.106 39.385 32.558ZM15.668 38.445C15.386 38.795 14.955 39 14.505 39C13.682 39 13.01 38.323 13.01 37.5C13.01 36.677 13.687 36 14.505 36C14.846 36 15.182 36.118 15.446 36.336C16.086 36.855 16.186 37.805 15.668 38.445Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringBoot);
export default __webpack_public_path__ + "static/media/spring-boot.2018fbe3c56c21aede9f9f496bb99f7c.svg";
export { ForwardRef as ReactComponent };